import { render } from "./ChatMessageNew.vue?vue&type=template&id=c9bae1b6&scoped=true"
import script from "./ChatMessageNew.vue?vue&type=script&lang=js"
export * from "./ChatMessageNew.vue?vue&type=script&lang=js"

import "./ChatMessageNew.vue?vue&type=style&index=0&id=c9bae1b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9bae1b6"]])

export default __exports__